import { FechaFunctionsService } from '@/utils/functions.service';
import { Component } from '@angular/core';
import { GeneralService } from '@services/general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pedidos-en-proceso',
  templateUrl: './pedidos-en-proceso.component.html',
  styleUrls: ['./pedidos-en-proceso.component.scss']
})
export class PedidosEnProcesoComponent {
  rowsRecepcionados: Array<any>;
  rowsEnProceso: Array<any>;
  isLoadingRecepcionados: boolean = false;
  isLoadingEnProceso: boolean = false;

  constructor(
    public generalService: GeneralService,
    private toastr: ToastrService,
    public FechaFunc: FechaFunctionsService) {
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.isLoadingRecepcionados = true
    let now = this.FechaFunc.NowDay();
    this.generalService.getListar(`pedido/todo?fecha_ingreso_to=${this.FechaFunc.DateFormatedBD(this.FechaFunc.DateFormated(this.FechaFunc.addDays(new Date, -365)))}&id_estado=1`)
      .then(res => {
        this.rowsRecepcionados = res.data;
        this.isLoadingRecepcionados = false
      })
      .catch(err => {
        console.log(err)
        this.isLoadingRecepcionados = false
      })
    this.isLoadingEnProceso = true
    this.generalService.getListar(`pedido/todo?fecha_ingreso_to=${this.FechaFunc.DateFormatedBD(this.FechaFunc.DateFormated(this.FechaFunc.addDays(new Date, -365)))}&id_estado=3`)
      .then(res => {
        this.rowsEnProceso = res.data;
        this.isLoadingEnProceso = false
      })
      .catch(err => {
        console.log(err)
        this.isLoadingEnProceso = false
      })
  }
}
